// src/auth.js

const USER_KEY = "user";      // stored JSON user object
const TOKEN_KEY = "token";    // raw JWT string

// Save user + token after login/signup
export function saveAuth(user) {
  if (!user) return;

  try {
    if (user.token) {
      localStorage.setItem(TOKEN_KEY, user.token);
    }
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  } catch (err) {
    console.warn("Failed to save auth data:", err);
  }
}

// Get current user object (or null)
export function getCurrentUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (err) {
    console.warn("Failed to read user from localStorage:", err);
    return null;
  }
}

// Get JWT token (or null)
export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

// Clear everything on logout
export function clearAuth() {
  try {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(TOKEN_KEY);
  } catch (err) {
    console.warn("Failed to clear auth data:", err);
  }
}

// Helper for protected API calls (admin, etc.)
export async function authFetch(url, options = {}) {
  const token = getToken();

  const headers = {
    "Content-Type": "application/json",
    ...(options.headers || {}),
  };

  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  const res = await fetch(url, {
    ...options,
    headers,
    // credentials: "include", // only needed if you also use cookies
  });

  return res;
}
